import { render, staticRenderFns } from "./r-tutorial-page.vue?vue&type=template&id=5a3caf26"
import script from "./r-tutorial-page.vue?vue&type=script&lang=js"
export * from "./r-tutorial-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3caf26')) {
      api.createRecord('5a3caf26', component.options)
    } else {
      api.reload('5a3caf26', component.options)
    }
    module.hot.accept("./r-tutorial-page.vue?vue&type=template&id=5a3caf26", function () {
      api.rerender('5a3caf26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/tutorial/r-tutorial-page.vue"
export default component.exports